import { useState } from 'react'

export function useDialog(defaultTitle?: string, defaultMessage?: string) {
  const [open, setOpen] = useState(false)
  const [title, setTitle] = useState<string>(defaultTitle ?? '')
  const [message, setMessage] = useState<string>(defaultMessage ?? '')

  const [trigger, setTrigger] = useState<{
    reject: (v: boolean) => void;
    resolve: (v: boolean) => void;
  }>();

  function show(m?: string, t?: string): Promise<boolean> {
    setOpen(true)
    if(m) setMessage(m)
    if(t) setTitle(t)

    return new Promise<boolean>((resolve, reject) => {
      setTrigger({ resolve, reject })
    })
  }

  // confirmed: a boolean to indicate if the user has confirmed the message
  function close(confirmed: boolean = false) {
    setOpen(false)
    if(trigger) {
      confirmed ? trigger.resolve(true) : trigger.reject(false)
      setTrigger(undefined)
    }
  }

  return {
    open,
    title,
    message,
    show,
    close
  }

}